import {Component, AfterViewInit} from '@angular/core';

// service
import {AppComponent} from '../../app.component';
import {Constant} from "../constant";
import {DataService} from "../service/data.service";
import {TranslateService} from "@ngx-translate/core";

declare let $: any;

@Component({
  selector: 'util-language',
  template: `
    <select id="language" class="language"
            [(ngModel)]="currentLang" name="currentLang" (change)="selectLang(currentLang)">
      <option *ngFor="let item of dataService.listLanguage" [value]="item.code"
              [selected]="currentLang === item.code"
      >{{item.name}}
      </option>
    </select>
  `
})

export class LanguageUtilComponent implements AfterViewInit {

  // Declare variable
  currentLang = localStorage.getItem(Constant.key_local_language);
  notRemoveClass: boolean = false;

  /**
   * function first run
   * */
  constructor(
              private translate: TranslateService,
              public dataService: DataService) {
    this.dataService.subData()
      .then((res: any) => {
        if (res) {
          this.dataService.listLanguage = res.listLanguage;
          this.init();
        }
      });
  }

  init() {
    let lang;
    let url = location.href.substring(location.href.indexOf('#') + 1, location.href.length);
    if (url.substring(0, 10) === Constant.url_detail_portfolio) this.notRemoveClass = true;
    if (window.URLSearchParams) {
      let params = new URLSearchParams(location.href.substring(location.href.indexOf('?') + 1, location.href.length));
      lang = params.get('language');
    }else {
      let params = location.href.substring(location.href.indexOf('?') + 1, location.href.length);
      if (params.indexOf('language=') !== -1) {
        lang = params.substring(params.indexOf('language=') + 9, params.length);
        if (lang.indexOf('&') !== -1) {
          lang = lang.substring(0, lang.indexOf('&'))
        }
      }
    }
    if (lang) {
      this.dataService.currentLang = lang;
      localStorage.setItem(Constant.key_local_language, lang);
      this.translate.use(lang);
    }

    if (this.dataService.currentLang) {
    }
  }

  /**
   * function handle when change language
   * @Params language
   * */
  selectLang(language) {

    // set current language
    this.dataService.currentLang = language;
    // save local
    localStorage.setItem(Constant.key_local_language, language);
    setTimeout(() => {
      location.reload()
    }, 500)
  }

  /**
   * function call back when init view done
   * */
  ngAfterViewInit() {
  }

}
